import api from '@/services/api';

export default {
  async syncReplicatedEntities() {
    try {
      let response = await api.put('Clients/Sync');
      if (response && response.status == 200) {
        return true;
      }
      return false;
    } catch (ex) {
      console.error(ex);
      return false;
    }
  }
}
